import { Component } from '@angular/core';
import { EstoqueHistorico } from '../../core/models/estoque-historico';
import { EstoqueHistoricoService } from 'src/app/core/services/estoque-historico.service';

@Component({
  selector: 'app-estoque-historico',
  templateUrl: './estoque-historico.component.html',
  styleUrls: ['./estoque-historico.component.scss'],
})
export class EstoqueHistoricoComponent {

  historicos: EstoqueHistorico[] = [];

  constructor(private servico: EstoqueHistoricoService) {}

  selecionar(): void {
    this.servico
      .selecionar()
      .subscribe((retorno) => (this.historicos = retorno));
  }

isAdicionado(operacao: string): boolean {
  return operacao.startsWith('Adicionado') || operacao.startsWith('Cancelada');
}

  //Método de inicialização
  ngOnInit() {
    this.selecionar();
  }
}
